module.exports = __webpack_public_path__ + "img/D4855F_92512D_AE6742_A75C2C-256px.72d08eaf.png";